import PropTypes from "prop-types"
import { get, noop, capitalize } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData, changeGroupSort as changeSort, getTitle } from "helpers/contributorsSort"
import { DATE } from "helpers/shapes"
import ExcelDownload from "components/excel-download"
import SortIcon from "components/sort-icon"

function DailyDetails({
  calculationType,
  disabled,
  data,
  factorTable,
  openFactorProfile,
  sort,
  order,
  csvData,
  noFactorDrilldown,
  drift,
  driftArrows,
  startDate,
  endDate,
}) {
  const currentOrder = get(order, "order")
  const sortedData = sortData(data, order)
  const changeHeaderTitle = startDate && endDate ? `Change from ${startDate} to ${endDate}` : "Change"

  return <>
    <ExcelDownload {...csvData} title={`Download factor ${calculationType}`} />
    <Table>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell align="right" title={getTitle(order, `% ${capitalize(calculationType)}`)}>
            <span className="sort" onClick={() => changeSort(sort, currentOrder)}>
              <SortIcon order={currentOrder} />
              %&nbsp;
              {capitalize(calculationType)}
            </span>
          </TableCell>
          {drift && <TableCell align="right" title={changeHeaderTitle}>
            Change
          </TableCell>}
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        factors
        allFactors
        drift={drift}
        driftArrows={driftArrows}
        driftType={capitalize(calculationType)}
        showDriftColumn={!!drift}
        openFactorProfile={openFactorProfile}
        data={sortedData}
        disabled={disabled}
        factorTable={factorTable}
        noFactorDrilldown={noFactorDrilldown}
        show={noop}
      />
    </Table>
  </>
}

DailyDetails.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  factorTable: PropTypes.bool.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  csvData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.array),
    fileName: PropTypes.string,
    type: PropTypes.string,
  }),
  noFactorDrilldown: PropTypes.bool,
  drift: PropTypes.object,
  driftArrows: PropTypes.object,
  calculationType: PropTypes.string,
  startDate: DATE,
  endDate: DATE,
}

export default DailyDetails
